var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    staticClass: "margin-10",
    attrs: { type: "checkbox", disabled: _vm.disabled === true },
    domProps: { checked: _vm.checked === true }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }